import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import { requestFailedMatcher } from '../request-failed/reducer';
import {
  type IGiftRegistryContribute,
  type IGiftRegistryContributeResponse,
  type IGiftRegistryPublicState,
} from './types';

const initialState: IGiftRegistryPublicState = {
  giftRegistry: null,
  shareToken: null,
  isContributing: false,
  contributeError: false,
  contributeRedirectLink: null,
};

const giftRegistryPublicSlice = createSlice({
  name: 'GiftRegistryPublic',
  initialState,
  reducers: {
    giftRegistryContribute: (
      state,
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      _action: IGiftRegistryContribute,
    ): void => {
      state.isContributing = true;
      state.contributeError = false;
      state.contributeRedirectLink = null;
    },
    giftRegistryContributeResponse: (
      state,
      action: PayloadAction<IGiftRegistryContributeResponse['payload']>,
    ) => {
      state.isContributing = false;

      if (action.payload.ok && action.payload.redirectLink) {
        state.contributeRedirectLink = action.payload.redirectLink;
      } else {
        state.contributeError = true;
      }
    },
  },
  extraReducers: (builder): void => {
    builder.addMatcher(
      requestFailedMatcher('GiftRegistryPublic'),
      (state): void => {
        if (state.isContributing) {
          state.isContributing = false;
          state.contributeError = true;
        }
      },
    );
  },
});

export const { giftRegistryContribute, giftRegistryContributeResponse } =
  giftRegistryPublicSlice.actions;

export default giftRegistryPublicSlice.reducer;
